require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-why-should-the-imf-eliminate-surcharges.json") })
        }
      }, "path---en-us-update-why-should-the-imf-eliminate-surcharges");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-why-should-the-imf-eliminate-surcharges!./.cache/json/en-us-update-why-should-the-imf-eliminate-surcharges.json
// module id = 867
// module chunks = 231608221292675